"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const i18n_1 = __importDefault(require("../../locales/settings/i18n"));
const FilterSearch = ({ autoFocus = false, fullWidth, defaultValue, onSubmit, onRefresh, forceUpdate = false, placeholder, }) => {
    const [q, setState] = (0, react_1.useState)(defaultValue ? defaultValue : "");
    const [isFocus, setFocus] = (0, react_1.useState)(false);
    const handleRefresh = () => {
        setState("");
        onSubmit(null);
        if (onRefresh) {
            onRefresh();
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(q || null);
    };
    (0, react_1.useEffect)(() => {
        if (forceUpdate) {
            onSubmit(q || null);
        }
    }, [q]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `react-search-module ${fullWidth ? "full-width" : "float-start"} ${isFocus ? "focus" : ""}` }, { children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Form, Object.assign({ noValidate: true, onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.Form.Control, { type: "text", name: "q", placeholder: placeholder || i18n_1.default.t("Search"), value: q, autoFocus: autoFocus, onChange: (e) => {
                        setState(e.target.value);
                    }, onFocus: () => {
                        setFocus(true);
                    }, onBlur: () => {
                        setFocus(false);
                    } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "search__refresh", onClick: handleRefresh, style: { display: q != "" ? "block" : "none" } }, { children: (0, jsx_runtime_1.jsx)("i", { className: "icon icon-close-empty" }) }))] })) })));
};
exports.default = FilterSearch;
